
import { Vue, Options } from 'vue-class-component'

@Options({
  components: {},
})
export default class AppLogoOnly extends Vue {}
